import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { APP_CONFIGURATION_TOKEN } from '../../app-configuration';


/**
 * Component that indicates the loading state of another component or page.
 */
@Component({
	selector: 'tsp-loader',
	templateUrl: './loader.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LoaderComponent {

	readonly LOADER_URL: string = `${inject(APP_CONFIGURATION_TOKEN).cdnUrl}/style/images/loading.gif`;

}
